const isLessOrEq = (min) => (value) => value <= min;
const isInBetween = (start, end) => (value) => value >= start && value <= end;
export {
  isInBetween,
  isLessOrEq
};
